import LoadingIcon from 'components/atoms/LoadingIcon'
import { CREATE_BOOKING_BTN_NEXT, CREATE_BOOKING_BTN_PREV } from '../bookingUiTokens'

const CreateBookingWizardFooter = ({ t, isLastStep, showPrevious, onPrevious, onNext, nextDisabled, showNext = true, isLoading = false }) => (
  <div className="sticky bottom-0 -mx-5 mt-8 border-t border-slate-200/80 bg-white/95 px-5 py-4 backdrop-blur-sm sm:-mx-7 sm:px-7 lg:-mx-10 lg:px-10">
    <div className="flex justify-between gap-3">
      {showPrevious ? (
        <button type="button" onClick={onPrevious} className={CREATE_BOOKING_BTN_PREV}>
          {t('bookingProfile.buttons.previous')}
        </button>
      ) : (
        <span />
      )}

      {!isLastStep && showNext && (
        <button type="button" onClick={onNext} disabled={nextDisabled || isLoading} className={CREATE_BOOKING_BTN_NEXT}>
          {isLoading ? (
            <span className="inline-flex items-center justify-center gap-2">
              <LoadingIcon />
              {t('bookingProfile.buttons.pleaseWait')}
            </span>
          ) : (
            t('bookingProfile.buttons.next')
          )}
        </button>
      )}
    </div>
  </div>
)

export default CreateBookingWizardFooter
